// From : http://stackoverflow.com/questions/4814398/how-can-i-check-if-a-scrollbar-is-visible#4814526
// Check the status of scrollbars on an element.
// Returns an object with true/false for vertical and horizontal scrollbars

export default function (e) {
  var e = e.get(0)
  return {
    vertical: e.scrollHeight > e.clientHeight,
    horizontal: e.scrollWidth > e.clientWidth
  }
}
